/* хармоничка, стъпки, мобилно меню */
(function(){

  /* една отворена секция: работи по клик, а не по toggle */
  document.addEventListener('click', function(e){
    var sum = e.target.closest ? e.target.closest('summary') : null;
    if(!sum) return;
    var det = sum.parentElement;
    if(!det || det.tagName !== 'DETAILS') return;
    e.preventDefault();
    var willOpen = !det.open;
    var parent = det.parentElement;
    var group = parent ? parent.children : [];
    for(var i=0;i<group.length;i++){
      var o = group[i];
      if(o.tagName !== 'DETAILS') continue;
      var isSelf = (o === det);
      o.open = isSelf ? willOpen : false;
      var ic = o.querySelector('.ic');
      if(ic) ic.textContent = o.open ? '–' : '+';
    }
  }, false);

  /* стъпките за употреба */
  var step = 0;
  window.nx = function(){
    var texts = document.querySelectorAll('.stp .s');
    var imgs  = document.querySelectorAll('.stp .imw > div');
    if(!texts.length) return;
    step = (step + 1) % texts.length;
    texts.forEach(function(el,k){ el.classList.toggle('on', k === step); });
    imgs.forEach(function(el,k){ el.classList.toggle('on', k === step); });
  };

  /* мобилно меню */
  window.emsieMenu = function(){
    var m = document.getElementById('mmenu');
    if(!m) return;
    var on = m.classList.toggle('on');
    document.body.style.overflow = on ? 'hidden' : '';
  };

})();
